<template>
  <b-card no-body class="d-flex flex-column flex-grow-1 mb-4">
    <b-card-body class="d-flex flex-column flex-grow-1" style="padding: 21px;">
      <router-link :to="detailTo(item.kode)">
        <b-card-title style="cursor:pointer" class="mb-0">{{item.product}}</b-card-title>
      </router-link>
      <div>{{item.last_update ? 'Last Updated : '+ $moment(item.last_update).format("dddd, Do MMMM YYYY") : ''}}</div>

      <b-card-text class="d-flex flex-column flex-grow-1 mt-2">
        <div class="flex-grow-1" v-html="item.short_description"></div>
        <router-link :to="detailTo(item.kode)">
          <div class="card-link float-right">
            Selengkapnya <feather-icon class="ml-1" icon="ChevronRightIcon" />
          </div>
        </router-link>
      </b-card-text>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BSpinner,BRow, BCol, BCard, BLink, BCardText, BCardTitle, BCardSubTitle, BDropdown, BDropdownItem , BButton,
  BCardBody
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    BSpinner,
    BRow,
    BCol,
    BCard,
    BCardBody,
    BLink,
    BCardText,
    BCardTitle,
    BCardSubTitle,
    BButton,
    BDropdown,
    BDropdownItem,
  },
  directives: {
    Ripple,
  },
  methods: {
    detail(id) {
      if(this.$route.meta.breadcrumb[1].text === 'Segmentation'){
        this.$router.push({name : 'product-segmentation-detail', params:{key:id}})
      }else if(this.$route.meta.breadcrumb[1].text === 'Targeting'){
        this.$router.push({name : 'product-targeting-detail', params:{key:id}})
      }
    },
    detailTo(id) {
      if(this.$route.meta.breadcrumb[1].text === 'Segmentation'){
        return {name : 'product-segmentation-detail', params:{key:id}}
      }else if(this.$route.meta.breadcrumb[1].text === 'Targeting'){
        return {name : 'product-targeting-detail', params:{key:id}}
      }else {
        return '#'
      }
    }
  }
}
</script>
